// Brand-voice copy — Phaedra can edit later.
export const CONTACT_EMAIL = "phaedra.elizabeth@gmail.com";
export const LOCATION = "New York City";

export const HERO_NAME = ["Phaedra", "Paulson"];
export const ROLES = ["Creative", "Artist", "Collaborator"];

export const INTRO =
  "Phaedra Paulson makes things move. She styles, builds and dreams up ideas across image, motion and social — hands always busy, point of view always loud and clear.";

// Editorial marquee — disciplines, not titles.
export const MARQUEE_ITEMS = [
  "Motion",
  "Image",
  "Form",
  "Concept",
  "Collaboration",
  "Editorial",
  "Craft",
  "Texture",
];

export const APPROACH = [
  {
    no: "01",
    title: "Hands-On",
    body:
      "If it can be built, pinned, draped or rigged, she's in. Materials, form, process — she gets right into it, from first spark to final frame.",
  },
  {
    no: "02",
    title: "Motion First",
    body:
      "Video is where it all clicks. Reels and short-form catch the texture, the movement and the energy a single photo never could.",
  },
  {
    no: "03",
    title: "Collaborative",
    body:
      "The good stuff happens in the room, together. Easy to work with, generous on set, and always up for one more idea.",
  },
  {
    no: "04",
    title: "Commercial Clarity",
    body:
      "Playful, never precious. Big creative swings that still land exactly what a brand needs.",
  },
];

export const SERVICES = [
  {
    no: "01",
    title: "Motion & Social",
    body:
      "Video for campaigns, social and look-books — the medium where the work shouts loudest.",
    tags: ["Reels", "Short-Form", "Social"],
  },
  {
    no: "02",
    title: "Concept & Mood",
    body:
      "The idea, the mood, the color story — the thread that pulls a whole project together.",
    tags: ["Concept", "Mood", "Color Story"],
  },
  {
    no: "03",
    title: "Image Making",
    body:
      "On-figure, product and editorial imagery, built on a real feel for form and material.",
    tags: ["On-Figure", "Product", "Editorial"],
  },
  {
    no: "04",
    title: "Craft & Material",
    body:
      "A maker's eye for how things come together — form, fit and finish steering every call.",
    tags: ["Form", "Fit", "Finish"],
  },
  {
    no: "05",
    title: "Collaboration",
    body:
      "An extra brain and two more hands for brands, studios and fellow artists chasing ambitious work.",
    tags: ["Studios", "Brands", "Artists"],
  },
];

export const ABOUT = {
  bio: [
    "Phaedra Paulson is an artist in New York City who moves easily between moving image, form and still work.",
    "She refuses to sit in one box — bouncing between social, motion and stills — always in service of smart, commercial work that still feels made by an actual human.",
  ],
  facts: [
    ["Based", "New York City"],
    ["Practice", "Artist"],
    ["Medium", "Motion · Image · Form"],
    ["For", "Brands · Studios · Artists"],
  ],
};

export const NAV = [
  { to: "/", label: "Home", index: "01" },
  { to: "/about", label: "About", index: "02" },
  { to: "/services", label: "Services", index: "03" },
  { to: "/gallery", label: "Gallery", index: "04" },
  { to: "/studio", label: "Studio", index: "05" },
  { to: "/reels", label: "Social", index: "06" },
  { to: "/contact", label: "Contact", index: "07" },
];

// Three-part identity — the top-level of the site.
export const PARTS = [
  { id: "stylist", to: "/", label: "Stylist" },
  { id: "maker", to: "/maker", label: "Maker" },
  { id: "kingsley", to: "/kingsley", label: "Kingsley" },
];
